/**
 * REBOA RCT (VIP 12) - Variable List
 * Variables currently used in 12NewCase.js
 * Total: 267 variables
 */

import React, { useState } from "react";

// ============================================================
// VARIABLE DEFINITIONS BY CATEGORY
// ============================================================

// Patient Demographics (10 variables)
export const PATIENT_DEMOGRAPHICS = [
  "pt_number",
  "pt_name",
  "date_of_birth",
  "age",
  "sex",
  "ed_arrival_datetime",
  "height",
  "weight",
  "waist_circumference",
  "hip_circumference",
];

// Inclusion Criteria (3 variables)
export const INCLUSION_CRITERIA = [
  "inclu_ohca",
  "inclu_witnessed",
  "inclu_age",
];

// Exclusion Criteria (9 variables)
export const EXCLUSION_CRITERIA = [
  "exclu_",
  "exclu_rosc",
  "exclu_cpc34",
  "exclu_bleeding",
  "exclu_aorticds",
  "exclu_dead",
  "exclu_ecmo",
  "exclu_traumatic",
  "exclu_request",
];

// Randomization (3 variables)
export const RANDOMIZATION = ["timeOfRandomization", "reboa", "confirm"];

// Arrest Information (9 variables)
export const ARREST_INFO = [
  "arrest_datetime",
  "arrest_lnt",
  "arrest_place",
  "baseline_cpc",
  "arrest_witness",
  "imm_compress",
  "bystander_cpr",
  "bystander_datetime",
  "bystander_aed",
];

// EMS Information (22 variables)
export const EMS_INFO = [
  "ems_call_datetime",
  "ems_arrival_datetimetime",
  "X2nd_arrive_time",
  "EMS_Departure_time",
  "ems_compression",
  "ems_compression_method",
  "ems_initial_rhythm",
  "ems_initial_rhythm_time",
  "ems_initial_rhythm_obsv",
  "ems_defib",
  "ems_defib_num",
  "ems_defib_energy",
  "ems_airway",
  "ems_airway_datetime",
  "ems_iv",
  "ems_iv_fluid",
  "ems_med_epi",
  "ems_epi_time",
  "ems_med_amio",
  "ems_amio_time",
  "ems_tor",
  "ems_tor_reason",
];

// ED Arrival & Transport (3 variables)
export const ED_ARRIVAL = [
  "ed_arrival_datetime2",
  "transport_method",
  "resus_room_datetime",
];

// Past Medical History (11 variables)
export const PAST_MEDICAL_HISTORY = [
  "pmhx_htn",
  "pmhx_dm",
  "pmxh_dl",
  "pmhx_lc",
  "pmhx_hf",
  "pmhx_stroke",
  "pmhx_caod",
  "pmhx_pacemaker",
  "pmhx_icd",
  "pmhx_ckd",
  "pmhx_malig",
];

// ED CPR (7 variables)
export const ED_CPR = [
  "ed_cpr_attempt",
  "ed_cpr_reason",
  "ed_compression_datetime",
  "ed_initial_rhythm",
  "ed_intubation",
  "ed_intubation_type",
  "ed_intubation_datetime",
];

// ACLS Medications (4 variables)
export const ACLS_MEDICATIONS = [
  "med_acls_epi",
  "med_acls_epi_time",
  "med_acls_amio",
  "med_acls_amio_dose",
];

// Defibrillation (3 variables)
export const DEFIBRILLATION = [
  "defib_datetime",
  "defib_energy",
  "defib_attempts",
];

// CPR Procedures (7 variables)
export const CPR_PROCEDURES = [
  "cpr_aline",
  "cpr_aline_time",
  "cpr_cline",
  "cpr_cline_time",
  "cpr_dis_time",
  "cpr_fluid",
  "cpr_dis_reason",
];

// Cause of Arrest (4 variables)
export const CAUSE_OF_ARREST = [
  "cause_arrest",
  "cause_medical",
  "cause_trauma",
  "cause_asphyxia",
];

// ROSC Information (6 variables)
export const ROSC_INFO = [
  "any_rosc",
  "rosc_ed",
  "nonsust_rosc_ed",
  "sust_rosc_ed",
  "rosc_ecg",
  "ed_outcome",
];

// Line Insertion (8 variables)
export const LINE_INSERTION = [
  "art_sheath_ins",
  "art_sheath_ins_site",
  "art_sheath_ins_attempts",
  "cline_ins",
  "cline_ins_site",
  "cline_ins_attempts",
  "abp_start_datetime",
  "cvp_start_datetime",
];

// REBOA Information (8 variables)
export const REBOA_INFO = [
  "reboa_ins",
  "reboa_ins_datetime",
  "reboa_ins_depth",
  "reboa_ins_attempts",
  "reboa_confirm",
  "reboa_inflation_datetime",
  "reboa_inflation_vol",
  "reboa_deflation_datetime",
];

// Device Related Complications (6 variables)
export const DEVICE_COMPLICATIONS = [
  "ae_malposition",
  "ae_ins_fail",
  "ae_ins_hematoma",
  "ae_ins_infection",
  "ae_balloon_rupture",
  "ae_removal_failure",
];

// Vascular Complications (4 variables)
export const VASCULAR_COMPLICATIONS = [
  "ae_fem_art_inj",
  "ae_limb_isch",
  "ae_amputation",
  "ae_aorta_inj",
];

// Other Adverse Events (16 variables)
export const OTHER_ADVERSE_EVENTS = [
  "ae_aki_dialysis",
  "ae_ards",
  "ae_bacteremia",
  "ae_pneumonia",
  "ae_sepsis",
  "ae_stroke",
  "ae_paraplegia",
  "ae_mi",
  "ae_mof",
  "ae_spinal_ische",
  "ae_vent_days",
  "ae_icu_stay",
  "ae_hospital_stay",
  "ae_hospital_mortality",
  "ae_mortality_hours",
  "ae_mortality_days",
];

// Treatment Information (9 variables)
export const TREATMENT_INFO = [
  "ttm",
  "ttm_temp",
  "ttm_cause",
  "cag",
  "pci",
  "cabg",
  "iabp",
  "crrt",
  "tcp",
];

// Lab Results - General (19 variables)
export const LAB_GENERAL = [
  "wbc",
  "hb",
  "plt",
  "na",
  "k",
  "cl",
  "tco2",
  "bun",
  "cr",
  "tbil",
  "ast",
  "alt",
  "ica",
  "phos",
  "alb",
  "alp",
  "pt",
  "aptt",
  "crp",
];

// Lab Results - Cardiac Markers (6 variables)
export const LAB_CARDIAC = [
  "ck",
  "ckmb",
  "troponin_i",
  "probnp",
  "ddimer",
  "nse",
];

// Lab Results - ABGA (7 variables)
export const LAB_ABGA = [
  "ph",
  "po2",
  "pco2",
  "hco3",
  "lactate",
  "sao2",
  "scvo2",
];

// Lab Results - Hormones (3 variables)
export const LAB_HORMONES = ["cortisol", "acth", "adh"];

// Discharge Outcome (4 variables)
export const DISCHARGE_OUTCOME = [
  "discharge_date",
  "discharge_type",
  "cpc_discharge",
  "mrs_discharge",
];

// Follow-up (6 variables)
export const FOLLOWUP = [
  "cpc_1month",
  "mrs_1month",
  "cpc_3month",
  "mrs_3month",
  "cpc_6month",
  "mrs_6month",
];

// Hemodynamics - Pre REBOA 2min (9 variables)
export const HEMODYNAMICS_PRE_2MIN = [
  "sbp_pre_2min",
  "dbp_pre_2min",
  "mbp_pre_2min",
  "hr_pre_2min",
  "rr_pre_2min",
  "spo2_pre_2min",
  "cvp_pre_2min",
  "etco2_pre_2min",
  "bt_pre_2min",
];

// Hemodynamics - Pre REBOA 1min (9 variables)
export const HEMODYNAMICS_PRE_1MIN = [
  "sbp_pre_1min",
  "dbp_pre_1min",
  "mbp_pre_1min",
  "hr_pre_1min",
  "rr_pre_1min",
  "spo2_pre_1min",
  "cvp_pre_1min",
  "etco2_pre_1min",
  "bt_pre_1min",
];

// Hemodynamics - Post REBOA 1min (9 variables)
export const HEMODYNAMICS_POST_1MIN = [
  "sbp_after_1min",
  "dbp_after_1min",
  "mbp_after_1min",
  "hr_after_1min",
  "rr_after_1min",
  "spo2_after_1min",
  "cvp_after_1min",
  "etco2_after_1min",
  "bt_after_1min",
];

// Hemodynamics - Post REBOA 2min (9 variables)
export const HEMODYNAMICS_POST_2MIN = [
  "sbp_after_2min",
  "dbp_after_2min",
  "mbp_after_2min",
  "hr_after_2min",
  "rr_after_2min",
  "spo2_after_2min",
  "cvp_after_2min",
  "etco2_after_2min",
  "bt_after_2min",
];

// Hemodynamics - Post REBOA 4min (9 variables)
export const HEMODYNAMICS_POST_4MIN = [
  "sbp_after_4min",
  "dbp_after_4min",
  "mbp_after_4min",
  "hr_after_4min",
  "rr_after_4min",
  "spo2_after_4min",
  "cvp_after_4min",
  "etco2_after_4min",
  "bt_after_4min",
];

// Hemodynamics - Post REBOA 10min (9 variables)
export const HEMODYNAMICS_POST_10MIN = [
  "sbp_after_10min",
  "dbp_after_10min",
  "mbp_after_10min",
  "hr_after_10min",
  "rr_after_10min",
  "spo2_after_10min",
  "cvp_after_10min",
  "etco2_after_10min",
  "bt_after_10min",
];

// Study Completion (4 variables)
export const STUDY_COMPLETION = [
  "study_completion",
  "withdraw_date",
  "withdraw_reason",
  "completion_date",
];

// Other Fields (1 variable)
export const OTHER_FIELDS = ["others"];

// Status Fields (7 variables)
export const STATUS_FIELDS = [
  "assessment_status",
  "prehospital_status",
  "ed_status",
  "reboa_status",
  "admission_status",
  "hemodynamics_status",
  "completion_status",
];

// System Fields (4 variables)
export const SYSTEM_FIELDS = ["hospital", "data_id", "case_id", "user_id"];

// ============================================================
// VARIABLE CATEGORIES MAPPING
// ============================================================

export const VARIABLE_CATEGORIES = {
  PATIENT_DEMOGRAPHICS: {
    label: "Patient Demographics",
    count: PATIENT_DEMOGRAPHICS.length,
    variables: PATIENT_DEMOGRAPHICS,
  },
  INCLUSION_CRITERIA: {
    label: "Inclusion Criteria",
    count: INCLUSION_CRITERIA.length,
    variables: INCLUSION_CRITERIA,
  },
  EXCLUSION_CRITERIA: {
    label: "Exclusion Criteria",
    count: EXCLUSION_CRITERIA.length,
    variables: EXCLUSION_CRITERIA,
  },
  RANDOMIZATION: {
    label: "Randomization",
    count: RANDOMIZATION.length,
    variables: RANDOMIZATION,
  },
  ARREST_INFO: {
    label: "Arrest Information",
    count: ARREST_INFO.length,
    variables: ARREST_INFO,
  },
  EMS_INFO: {
    label: "EMS Information",
    count: EMS_INFO.length,
    variables: EMS_INFO,
  },
  ED_ARRIVAL: {
    label: "ED Arrival & Transport",
    count: ED_ARRIVAL.length,
    variables: ED_ARRIVAL,
  },
  PAST_MEDICAL_HISTORY: {
    label: "Past Medical History",
    count: PAST_MEDICAL_HISTORY.length,
    variables: PAST_MEDICAL_HISTORY,
  },
  ED_CPR: {
    label: "ED CPR",
    count: ED_CPR.length,
    variables: ED_CPR,
  },
  ACLS_MEDICATIONS: {
    label: "ACLS Medications",
    count: ACLS_MEDICATIONS.length,
    variables: ACLS_MEDICATIONS,
  },
  DEFIBRILLATION: {
    label: "Defibrillation",
    count: DEFIBRILLATION.length,
    variables: DEFIBRILLATION,
  },
  CPR_PROCEDURES: {
    label: "CPR Procedures",
    count: CPR_PROCEDURES.length,
    variables: CPR_PROCEDURES,
  },
  CAUSE_OF_ARREST: {
    label: "Cause of Arrest",
    count: CAUSE_OF_ARREST.length,
    variables: CAUSE_OF_ARREST,
  },
  ROSC_INFO: {
    label: "ROSC Information",
    count: ROSC_INFO.length,
    variables: ROSC_INFO,
  },
  LINE_INSERTION: {
    label: "Line Insertion",
    count: LINE_INSERTION.length,
    variables: LINE_INSERTION,
  },
  REBOA_INFO: {
    label: "REBOA Information",
    count: REBOA_INFO.length,
    variables: REBOA_INFO,
  },
  DEVICE_COMPLICATIONS: {
    label: "Device Related Complications",
    count: DEVICE_COMPLICATIONS.length,
    variables: DEVICE_COMPLICATIONS,
  },
  VASCULAR_COMPLICATIONS: {
    label: "Vascular Complications",
    count: VASCULAR_COMPLICATIONS.length,
    variables: VASCULAR_COMPLICATIONS,
  },
  OTHER_ADVERSE_EVENTS: {
    label: "Other Adverse Events",
    count: OTHER_ADVERSE_EVENTS.length,
    variables: OTHER_ADVERSE_EVENTS,
  },
  TREATMENT_INFO: {
    label: "Treatment Information",
    count: TREATMENT_INFO.length,
    variables: TREATMENT_INFO,
  },
  LAB_GENERAL: {
    label: "Lab Results - General",
    count: LAB_GENERAL.length,
    variables: LAB_GENERAL,
  },
  LAB_CARDIAC: {
    label: "Lab Results - Cardiac Markers",
    count: LAB_CARDIAC.length,
    variables: LAB_CARDIAC,
  },
  LAB_ABGA: {
    label: "Lab Results - ABGA",
    count: LAB_ABGA.length,
    variables: LAB_ABGA,
  },
  LAB_HORMONES: {
    label: "Lab Results - Hormones",
    count: LAB_HORMONES.length,
    variables: LAB_HORMONES,
  },
  DISCHARGE_OUTCOME: {
    label: "Discharge Outcome",
    count: DISCHARGE_OUTCOME.length,
    variables: DISCHARGE_OUTCOME,
  },
  FOLLOWUP: {
    label: "Follow-up",
    count: FOLLOWUP.length,
    variables: FOLLOWUP,
  },
  HEMODYNAMICS_PRE_2MIN: {
    label: "Hemodynamics - Pre REBOA 2min",
    count: HEMODYNAMICS_PRE_2MIN.length,
    variables: HEMODYNAMICS_PRE_2MIN,
  },
  HEMODYNAMICS_PRE_1MIN: {
    label: "Hemodynamics - Pre REBOA 1min",
    count: HEMODYNAMICS_PRE_1MIN.length,
    variables: HEMODYNAMICS_PRE_1MIN,
  },
  HEMODYNAMICS_POST_1MIN: {
    label: "Hemodynamics - Post REBOA 1min",
    count: HEMODYNAMICS_POST_1MIN.length,
    variables: HEMODYNAMICS_POST_1MIN,
  },
  HEMODYNAMICS_POST_2MIN: {
    label: "Hemodynamics - Post REBOA 2min",
    count: HEMODYNAMICS_POST_2MIN.length,
    variables: HEMODYNAMICS_POST_2MIN,
  },
  HEMODYNAMICS_POST_4MIN: {
    label: "Hemodynamics - Post REBOA 4min",
    count: HEMODYNAMICS_POST_4MIN.length,
    variables: HEMODYNAMICS_POST_4MIN,
  },
  HEMODYNAMICS_POST_10MIN: {
    label: "Hemodynamics - Post REBOA 10min",
    count: HEMODYNAMICS_POST_10MIN.length,
    variables: HEMODYNAMICS_POST_10MIN,
  },
  STUDY_COMPLETION: {
    label: "Study Completion",
    count: STUDY_COMPLETION.length,
    variables: STUDY_COMPLETION,
  },
  OTHER_FIELDS: {
    label: "Other Fields",
    count: OTHER_FIELDS.length,
    variables: OTHER_FIELDS,
  },
  STATUS_FIELDS: {
    label: "Status Fields",
    count: STATUS_FIELDS.length,
    variables: STATUS_FIELDS,
    isSystem: true,
  },
  SYSTEM_FIELDS: {
    label: "System Fields",
    count: SYSTEM_FIELDS.length,
    variables: SYSTEM_FIELDS,
    isSystem: true,
  },
};

// ============================================================
// ALL VARIABLES LIST
// ============================================================

export const ALL_VARIABLES = [
  ...PATIENT_DEMOGRAPHICS,
  ...INCLUSION_CRITERIA,
  ...EXCLUSION_CRITERIA,
  ...RANDOMIZATION,
  ...ARREST_INFO,
  ...EMS_INFO,
  ...ED_ARRIVAL,
  ...PAST_MEDICAL_HISTORY,
  ...ED_CPR,
  ...ACLS_MEDICATIONS,
  ...DEFIBRILLATION,
  ...CPR_PROCEDURES,
  ...CAUSE_OF_ARREST,
  ...ROSC_INFO,
  ...LINE_INSERTION,
  ...REBOA_INFO,
  ...DEVICE_COMPLICATIONS,
  ...VASCULAR_COMPLICATIONS,
  ...OTHER_ADVERSE_EVENTS,
  ...TREATMENT_INFO,
  ...LAB_GENERAL,
  ...LAB_CARDIAC,
  ...LAB_ABGA,
  ...LAB_HORMONES,
  ...DISCHARGE_OUTCOME,
  ...FOLLOWUP,
  ...HEMODYNAMICS_PRE_2MIN,
  ...HEMODYNAMICS_PRE_1MIN,
  ...HEMODYNAMICS_POST_1MIN,
  ...HEMODYNAMICS_POST_2MIN,
  ...HEMODYNAMICS_POST_4MIN,
  ...HEMODYNAMICS_POST_10MIN,
  ...STUDY_COMPLETION,
  ...OTHER_FIELDS,
  ...STATUS_FIELDS,
  ...SYSTEM_FIELDS,
];

export const TOTAL_VARIABLE_COUNT = ALL_VARIABLES.length;

// ============================================================
// REACT COMPONENT
// ============================================================

const VIP12Variable = () => {
  const [expandedCategories, setExpandedCategories] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const toggleCategory = (categoryKey) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [categoryKey]: !prev[categoryKey],
    }));
  };

  const expandAll = () => {
    const allExpanded = {};
    Object.keys(VARIABLE_CATEGORIES).forEach((key) => {
      allExpanded[key] = true;
    });
    setExpandedCategories(allExpanded);
  };

  const collapseAll = () => {
    setExpandedCategories({});
  };

  // Filter categories based on search term
  const filteredCategories = Object.entries(VARIABLE_CATEGORIES).filter(
    ([key, category]) => {
      if (!searchTerm) return true;
      const term = searchTerm.toLowerCase();
      return (
        category.label.toLowerCase().includes(term) ||
        category.variables.some((v) => v.toLowerCase().includes(term))
      );
    }
  );

  // Calculate total count
  const totalCount = Object.values(VARIABLE_CATEGORIES).reduce(
    (sum, cat) => sum + cat.count,
    0
  );

  const categoryCount = Object.keys(VARIABLE_CATEGORIES).length;

  return (
    <div
      style={{
        padding: "24px",
        maxWidth: "1200px",
        margin: "0 auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {/* Header */}
      <div
        style={{
          marginBottom: "32px",
          borderBottom: "2px solid #dc2626",
          paddingBottom: "16px",
        }}
      >
        <h1
          style={{
            fontSize: "28px",
            fontWeight: "700",
            color: "#1f2937",
            marginBottom: "8px",
          }}
        >
          REBOA RCT - Variable List
        </h1>
        <p style={{ color: "#6b7280", fontSize: "14px" }}>
          variable list for REBOA RCT
        </p>
      </div>

      {/* Summary Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
            borderRadius: "12px",
            padding: "20px",
            color: "white",
          }}
        >
          <div style={{ fontSize: "36px", fontWeight: "700" }}>
            {totalCount}
          </div>
          <div style={{ fontSize: "14px", opacity: 0.9 }}>Total Variables</div>
        </div>
        <div
          style={{
            background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
            borderRadius: "12px",
            padding: "20px",
            color: "white",
          }}
        >
          <div style={{ fontSize: "36px", fontWeight: "700" }}>
            {categoryCount}
          </div>
          <div style={{ fontSize: "14px", opacity: 0.9 }}>Categories</div>
        </div>
      </div>

      {/* Search and Controls */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          marginBottom: "24px",
          flexWrap: "wrap",
        }}
      >
        <input
          type="text"
          placeholder="Search variables..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            flex: "1",
            minWidth: "200px",
            padding: "10px 16px",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "14px",
          }}
        />
        <button
          onClick={expandAll}
          style={{
            padding: "10px 20px",
            backgroundColor: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Expand All
        </button>
        <button
          onClick={collapseAll}
          style={{
            padding: "10px 20px",
            backgroundColor: "#6b7280",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Collapse All
        </button>
      </div>

      {/* Category List */}
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {filteredCategories.map(([key, category]) => (
          <div
            key={key}
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            {/* Category Header */}
            <div
              onClick={() => toggleCategory(key)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                backgroundColor: expandedCategories[key] ? "#f9fafb" : "white",
                cursor: "pointer",
                transition: "background-color 0.2s",
              }}
            >
              <div>
                <span
                  style={{
                    fontWeight: "600",
                    color: "#1f2937",
                    marginRight: "8px",
                  }}
                >
                  {category.label}
                </span>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <span
                  style={{
                    backgroundColor: category.isSystem ? "#8b5cf6" : "#dc2626",
                    color: "white",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {category.count} variables
                </span>
                <span
                  style={{
                    fontSize: "18px",
                    color: "#6b7280",
                    transition: "transform 0.2s",
                    transform: expandedCategories[key]
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  }}
                >
                  ▼
                </span>
              </div>
            </div>

            {/* Variable List */}
            {expandedCategories[key] && (
              <div
                style={{
                  padding: "16px 20px",
                  backgroundColor: "#f9fafb",
                  borderTop: "1px solid #e5e7eb",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "8px",
                  }}
                >
                  {category.variables
                    .filter(
                      (v) =>
                        !searchTerm ||
                        v.toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .map((variable, index) => (
                      <div
                        key={variable}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 12px",
                          backgroundColor: "white",
                          borderRadius: "6px",
                          border: "1px solid #e5e7eb",
                          fontSize: "13px",
                        }}
                      >
                        <span
                          style={{
                            color: "#9ca3af",
                            fontSize: "11px",
                            minWidth: "20px",
                          }}
                        >
                          {index + 1}.
                        </span>
                        <code
                          style={{
                            fontFamily: "monospace",
                            color: category.isSystem ? "#7c3aed" : "#dc2626",
                            backgroundColor: category.isSystem
                              ? "#f3e8ff"
                              : "#fef2f2",
                            padding: "2px 6px",
                            borderRadius: "4px",
                          }}
                        >
                          {variable}
                        </code>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Footer */}
      <div
        style={{
          marginTop: "32px",
          padding: "16px",
          backgroundColor: "#f3f4f6",
          borderRadius: "8px",
          fontSize: "13px",
          color: "#6b7280",
        }}
      >
        <p>
          <strong>Note:</strong> This variable list is extracted from
          12NewCase.js initialFormData. For any questions or modifications,
          please contact the administrator.
        </p>
      </div>
    </div>
  );
};

export default VIP12Variable;
